import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signIn } from "../services";
import { toast } from "react-toastify";
import Logo from "../images/LogoLAENEW.png";
import LogoWhite from "../images/LAE.png";
import ImagenLogin from "../images/legal_ia_login_bg_img.png";

const NewLogin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [loginDatos, setLoginDatos] = useState({
    email: "",
    password: "",
  });

  function handleChange(evt) {
    const value = evt.target.value;
    setLoginDatos({
      ...loginDatos,
      [evt.target.name]: value,
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (loginDatos.email === "" || loginDatos.password === "") {
      toast.error("Rellena todos los campos");
    } else {
      setIsLoading(true);
      signIn(loginDatos)
        .then((response) => {
          setIsLoading(false);

          const status = response?.status || response?.response?.status;

          if (status === 200) {
            navigate(location.state?.from?.pathname || "/");
          } else if (response?.status === 403) {
            const { token } = response.data;
            toast.warning("Usuario no verificado");
            navigate(`/nuevaPassword/${token}/login`);
          } else if (
            response?.status === 401 ||
            response?.status === 404 ||
            response?.status === 400
          ) {
            toast.error("Credenciales incorrectas");
          } else if (response?.code === "ERR_NETWORK" || !status) {
            toast.error("No se pudo conectar con el servidor.");
          } else {
            toast.error("Error del servidor");
          }
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
          toast.error("Error del servidor");
        });
    }
  }

  return (
    <div className="flex min-h-screen bg-white relative overflow-hidden">
      <div className="lg:w-1/2 lg:p-4 max-lg:fixed max-lg:inset-0 max-lg:w-full max-lg:h-full max-lg:p-0">
        <div
          className="relative w-full h-full lg:rounded-3xl overflow-hidden bg-gray-400 bg-cover bg-center"
          style={{ backgroundImage: `url(${ImagenLogin})` }}
        >
          <div className="absolute inset-0 lg:bg-gradient-to-t lg:from-black/75 lg:to-transparent max-lg:bg-black/50" />
          <p className="absolute bottom-10 left-10 text-white text-5xl font-semibold leading-tight max-lg:hidden">
            Analiza, conecta y<br />
            optimiza las<br />
            comunidades
          </p>
        </div>
      </div>

      <div className="relative w-full lg:w-1/2 flex flex-col min-h-screen z-[1]">
        <div className="text-center pt-10 px-6">
          <img src={Logo} alt="GRUPOLAE FINCAS" className="h-[105px] object-contain mx-auto hidden lg:block" />
          <img src={LogoWhite} alt="GRUPOLAE FINCAS" className="h-[105px] object-contain mx-auto lg:hidden" />
        </div>

        <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 max-lg:justify-start max-lg:pt-[17vh]">
          <div className="w-full max-w-[420px] max-lg:bg-white max-lg:rounded-2xl max-lg:p-8 max-lg:shadow-lg max-lg:max-w-[400px]">
            <div className="mb-8">
              <h1 className="text-2xl font-bold text-gray-900 tracking-tight mb-1">Te damos la bienvenida</h1>
              <p className="text-lg text-gray-500">Accede a tu cuenta</p>
            </div>

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Email"
                value={loginDatos.email}
                onChange={handleChange}
                autoComplete="email"
                className="w-full h-12 px-4 text-[15px] text-gray-900 bg-white border border-gray-300 rounded-xl outline-none transition-all duration-150 placeholder:text-gray-400 focus:!outline-none focus:!border-[#92004D] focus:!shadow-none"
              />

              <input
                id="password"
                name="password"
                type="password"
                placeholder="Contraseña"
                value={loginDatos.password}
                onChange={handleChange}
                autoComplete="current-password"
                className="w-full h-12 px-4 text-[15px] text-gray-900 bg-white border border-gray-300 rounded-xl outline-none transition-all duration-150 placeholder:text-gray-400 focus:!outline-none focus:!border-[#92004D] focus:!shadow-none"
              />

              <button
                type="submit"
                disabled={isLoading}
                className="flex items-center justify-center w-full h-12 mt-2 px-6 text-[15px] font-medium text-white bg-slate-800 border-none rounded-xl cursor-pointer transition-colors duration-150 hover:bg-slate-700 disabled:!bg-slate-800 disabled:!text-white disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {isLoading ? "Cargando..." : "Iniciar sesión"}
              </button>
            </form>

            <div className="text-center mt-4">
              <Link to="/cambiarPassword" target="_blank" className="text-[13px] text-gray-500 no-underline transition-colors duration-150 hover:text-[#92004D]">
                ¿Has olvidado tu contraseña?
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewLogin;
